export const antConfig = (data) => {

  let configResponse = {
    token: {
      colorPrimary: data?.color?.primary_color || "#5c2d91",
      borderRadius: "8px",
      fontSize: 14,
      fontFamily: `"Poppins", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif`,
    },
  };
  return configResponse;
};
